// extracted by mini-css-extract-plugin
module.exports = {"root":"_025a50318d--root--3oOTU","header":"_025a50318d--header--3ES9k","icon":"_025a50318d--icon--9TE0C"};